module.exports = __webpack_public_path__ + "static/media/agregar_participantes_externos_saliente_v2.ccee717b.xlsm";